import { render, staticRenderFns } from "./OrderListServing.vue?vue&type=template&id=be633b1a&"
import script from "./OrderListServing.vue?vue&type=script&lang=ts&"
export * from "./OrderListServing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports